module.exports = __webpack_public_path__ + "candle.9cb90b19.png";